import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/guide-tips/fill-out-prescription/page.client.tsx");
